const exemptionJSON = localStorage.getItem('geoipExemptionData')
let exemptionData = null
if(exemptionJSON) {
  exemptionData = JSON.parse(exemptionJSON)
}

// Caching variable to prevent duplicate fetch requests
let currentLocale = null

// Returns user locale via geoip
async function getLocale() {
  if(currentLocale) return currentLocale
  const res = await fetch('/browsing_context_suggestions.json')
  const { detected_values } = await res.json()
  currentLocale = detected_values.country.handle
  return currentLocale
}

function setExemptionData(isoCode = Shopify.country) {
  localStorage.setItem('geoipExemptionData', JSON.stringify({ date: Date.now(), isoCode }))
}

// Handle automatic redirection for user currency
async function attemptCurrencyRedirect() {
  if(!hasExemptionExpired()) return // No need to attempt a redirect if an exemption is still in place
  const userIsoCode = await getLocale()
  const currentIsoCode = Shopify.country
  if(userIsoCode === currentIsoCode) return // If store is already correct there's no need to redirect

  setExemptionData(userIsoCode)
  performRedirect(userIsoCode,currentIsoCode)
}

function hasExemptionExpired() {
  if(!exemptionData) return true

  const then = new Date(exemptionData.date)
  const now = new Date()
  const msBetweenDates = Math.abs(then.getTime() - now.getTime())
  const daysBetweenDates = msBetweenDates / (24 * 60 * 60 * 1000)
  if (daysBetweenDates < 30) return false
  return true
}


function closeModal() {
  const geoipModal = document.querySelector('.geo-ip-modal-container');
  geoipModal.classList.remove('active');
}

function performRedirect(userIsoCode,currentIsoCode) {
  const geoipModal = document.querySelector('.geo-ip-modal-container');
  const geoipModalTitle = geoipModal.querySelector('h2');
  const geoipModalContent = geoipModal.querySelector('p');
  const geoipModalRedirectLink = geoipModal.querySelector('#recommended-store')
  const popup = document.querySelector('#PopupStore').querySelectorAll('a.flag');
  
  // Hard Redirect
  popup.forEach(
  function(currentValue) {
    const value = currentValue.attributes.value.value;
    if(value == userIsoCode) {
      if (window.geoip[value].hard_redirect) {
        window.location.href = window.geoip[value].url;
        return;
      }
      geoipModalTitle.innerHTML = window.geoip[value].title;
      geoipModalContent.innerHTML = window.geoip[value].content;
      geoipModalRedirectLink.href = window.geoip[value].url;
      geoipModalRedirectLink.innerText = window.geoip[value].button_text;
      geoipModal.classList.add('active');
    }
  }
);
}

;(async () => {
  await attemptCurrencyRedirect() // Step 2 - if no currency is stored and the user is on the correct store, attempt a GeoIP redirect
})()